import { render, staticRenderFns } from "./unbindingDialog.vue?vue&type=template&id=3a976e78"
import script from "./unbindingDialog.vue?vue&type=script&lang=js"
export * from "./unbindingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports